<template>
  <tbody>
    <slot></slot>
  </tbody>
</template>

<script>
export default {};
</script>

<style></style>
